"use strict";

const template = document.createElement("template");
template.innerHTML = require("./template");

const Button = require("../button/index");


class IconButton extends Button {
    constructor() {
        super(template);

        // this.root = this.attachShadow({ mode: "open" });
        //
        // // const template = document.getElementById("details-page-template");
        // const content = template.content.cloneNode(true);
        // this.root.appendChild(content);
        // this.button = this.root.querySelector("button");
        // this.button.innerHTML = this.innerHTML;
        // this.innerHTML = "";

    }


}

window.customElements.define("swiftref-icon-button", IconButton);

module.exports = Button;
